import React from 'react';
import { Stack } from '@mui/material';

import { PropertySelectField } from '@paragon/client-tools';
import { BeamOrientation } from '@paragon/contract-library';
import { DistanceField } from '@paragon/material';

import { getBearingEnvelopeHeight } from '../../../../../../store/selectors/layoutDataSelectors';
import { BearingEnvelopePropertiesProps } from './BearingEnvelopeProperties';

const BEAM_ORIENTATIONS: readonly BeamOrientation[] = ['Drop', 'Flush'];

export function BearingEnvelopeBeamProperties(props: BearingEnvelopePropertiesProps) {
  if (props.properties.bearingType !== 'Beam') return null;

  const height = getBearingEnvelopeHeight(props.properties);
  if (height == null) return null;

  return (
    <Stack direction="row" spacing={1}>
      <PropertySelectField<BeamOrientation>
        property="Beam Type"
        disabled={props.disabled}
        value={props.properties.beamOrientation}
        options={BEAM_ORIENTATIONS}
        getName={(beamOrientation) => `${beamOrientation} Beam`}
        submit={(beamOrientation) => {
          props.onChange({ beamOrientation });
        }}
      />

      <DistanceField
        label="Depth"
        disabled={props.disabled}
        min={1 / 16}
        value={height}
        onSubmit={(newHeight) => {
          if (props.properties.top == null || props.properties.bottom == null) return;

          props.onChange(
            props.properties.beamOrientation === 'Flush'
              ? { top: props.properties.bottom + newHeight }
              : { bottom: props.properties.top - newHeight },
          );
        }}
      />
    </Stack>
  );
}
